import React from "react";
import { STORAGE_ASSETS } from "../../Const/BaseUrlConst";

type ArrowLRigthProps = React.HTMLAttributes<HTMLDivElement> & {};

export const ArrowRigth: React.FC<ArrowLRigthProps> = ({ ...props }) => {
  return (
    <div {...props}>
      <img src={STORAGE_ASSETS+"/images/svg/arrow_rigth.svg"} alt="" />
    </div>
  );
};